import { getApolloContext } from '@apollo/client';
import { useContext } from 'react';

import FullPageLoadingSkeleton from './FullPageLoadingSkeleton';
import FullPageLoadingSpinner from './FullPageLoadingSpinner';

export default function FullPageLoadingContainer() {
	// This container also renders as a Suspense fallback outside the
	// ApolloProvider, where the session-slots query cannot run.
	const { client } = useContext(getApolloContext());

	if (!client) {
		return <FullPageLoadingSpinner />;
	}

	return <FullPageLoadingSkeleton />;
}
